// extracted by mini-css-extract-plugin
export var Preloader = "Preloader-module--Preloader--ap0gf";
export var Wrap = "Preloader-module--Wrap--guas1";
export var Logo = "Preloader-module--Logo--dej7H";
export var arrowLeft = "Preloader-module--arrowLeft--KsfNn";
export var arrowRight = "Preloader-module--arrowRight--3QT0i";